import React, { useEffect } from "react";
import { useState } from "react";
import Controls from "src/components/form/controls/Controls";
import useForm, { Form } from "src/hooks/useForm";
import { validationFLFRogoDevTypeInput } from "src/pages/FPTLife/utils/validateInput";
import { isDisableSubmit } from "src/utils";

const initialValue = {
  id: "",
  name: "",
  devTypeCode: 0,
  devTypeStr: "",
};

function FLFRogoDevTypeForm(props) {
  const { addOrEdit, recordForEdit, errorsForm } = props;
  const [valueAddNew, setValueAddNew] = useState(initialValue);

  // validation input permission
  const validateFLFRogoDevTypeForm = (fieldValues = values) => {
    let temp = validationFLFRogoDevTypeInput(fieldValues, { ...errors });

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialValue, true, validateFLFRogoDevTypeForm);

  const onSubmit = (e) => {
    e.preventDefault();
    if (validateFLFRogoDevTypeForm()) {
      addOrEdit(values, resetForm);
      setValueAddNew(initialValue);
    }
  };

  useEffect(() => {
    setErrors({
      ...errorsForm,
    });
  }, [errorsForm, setErrors]);

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues({
        ...recordForEdit,
      });
    } else {
      setValues({
        ...valueAddNew,
      });
      setErrors({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordForEdit]);

  const handleOnChange = (e) => {
    handleInputChange(e);

    if (!recordForEdit) {
      const { name, value, type } = e.target;
      setValueAddNew({
        ...valueAddNew,
        [name]: type === "number" ? +value : value,
      });
    }
  };

  return (
    <Form onSubmit={onSubmit}>
      <Controls.Input
        name="name"
        value={values.name}
        label="Name"
        type="text"
        onChange={handleOnChange}
        error={errors.name}
      />

      <Controls.Input
        name="devTypeCode"
        value={values.devTypeCode}
        label="Rogo Dev Type Code"
        type="number"
        onChange={handleOnChange}
        error={errors.devTypeCode}
      />
      <Controls.Input
        name="devTypeStr"
        value={values.devTypeStr}
        label="Rogo Dev Type String"
        type="text"
        onChange={handleOnChange}
        error={errors.devTypeStr}
      />

      <Controls.Button
        sx={{ width: "100%", marginTop: "10px" }}
        type="submit"
        text="Submit"
        disabled={isDisableSubmit(recordForEdit, values)}
      />
    </Form>
  );
}

export default FLFRogoDevTypeForm;
